import React from "react";
import TicketStaffList from '../js/TicketStaffList';

function StaffTickets () {
    return (<TicketStaffList/>);
};

export default StaffTickets